/* ADD Knowledge categories */
export const FINISH_LESSON = "FINISH_LESSON"
export const FINISH_LESSON_SUCCESS = "FINISH_LESSON_SUCCESS"
export const FINISH_LESSON_CLEAN = "FINISH_LESSON_CLEAN"
export const FINISH_LESSON_ERROR = "FINISH_LESSON_ERROR"
